import styled from "styled-components";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Header(){

    const navigate = useNavigate();
    const [menuOpen, setMenuOpen] = useState(false);

    return(
        <Content>
            <Top>
                <img className="logoPortal" src="/img/logo-portal.png" alt="" />
                <img className="logoZap" src="/img/logo-preta.png" alt="" />
            </Top>

            <Bottom>
                <MenuToggle onClick={() => setMenuOpen(!menuOpen)}>
                    <div className={menuOpen ? "bar open" : "bar"}></div>
                    <div className={menuOpen ? "bar open" : "bar"}></div>
                    <div className={menuOpen ? "bar open" : "bar"}></div>
                </MenuToggle>

                <Nav open={menuOpen}>
                    <p onClick={() => {navigate("/"); setMenuOpen(false);}}>Início</p>
                    <p onClick={() => {navigate("/o-bairro"); setMenuOpen(false);}}>O Bairro</p>
                    <p onClick={() => {navigate("/pontos-turisticos"); setMenuOpen(false);}}>Pontos Turísticos</p>
                    <p onClick={() => {navigate("/"); setMenuOpen(false);}}>Utilidades</p>
                    <p onClick={() => {navigate("/"); setMenuOpen(false);}}>Notícias</p>
                    <p onClick={() => {navigate("/contato"); setMenuOpen(false);}}>Fale Conosco</p>
                    <p onClick={() => {navigate("//wa.me/5521975376545"); setMenuOpen(false);}}>Ipanema Presente</p> 
                </Nav>
            </Bottom>
        </Content>
    );
}

const Content = styled.header`
    width: 100vw;
    box-sizing: border-box;
    overflow-x: hidden;

    @media (max-width: 768px) {
        padding-bottom: 10px;
    }
`;

const Top = styled.section`
    width: 100%;
    height: 130px;

    background-color: #FFFFFF;


    display: flex;
    justify-content: space-around;
    align-items: center;
    
    .logoPortal{
        height: 80%;
    }
    .logoZap{
        height: 60%;
    }

    @media (max-width: 768px) {
        height: 200px;
        flex-direction: column;
        .logoPortal{
            width: 80%;
            height: auto;
        }
        .logoZap{
            width: 60%;
            height: auto;
        }
    }
`;

const Bottom = styled.section`
    width: 100%;
    height: 70px;
    background-color: #F8F9FA;

    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 768px) {
        height: 80px;
    }
`;

const Nav = styled.nav`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 30px;
    background-color: #F8F9FA;


    p{
        color: #0000008C;
        position: relative;
        padding: 8px;
        cursor: pointer;
        font-family: 'Poppins', sans-serif;
        font-size: 16px;
        transition: color 0.3s ease;
        background-color: #F8F9FA;

        &::after {
            content: "";
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 2px;
            background: #000000E6;
            transform: scaleX(0);
            transform-origin: left;
            transition: transform 0.3s ease;
        }

        &:hover {
            color: #000000E6;
        }

        &:hover::after {
            transform: scaleX(1);
        }
    }
    
    @media (max-width: 768px) {
        position: absolute;
        top: 280px;
        right: 0;
        flex-direction: column;
        background-color: #F8F9FA;
        width: 100%;
        max-height: ${({ open }) => (open ? "300px" : "0")};
        overflow: hidden;
        transition: max-height 0.4s ease;
        box-shadow: ${({ open }) => (open ? "0 4px 20px rgba(0,0,0,0.1)" : "none")};
        gap: 15px;
        padding: ${({ open }) => (open ? "20px 0" : "0")};
        text-align: center;

        p {
            font-size: 18px;
        }
    }
`;

const MenuToggle = styled.div`
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 26px;
  height: 18px;
  cursor: pointer;

  .bar {
    height: 3px;
    width: 100%;
    background-color: #333;
    border-radius: 5px;
    transition: all 0.3s ease;
  }

  .bar.open:nth-child(1) {
    transform: rotate(45deg) translate(5px, 5px);
  }

  .bar.open:nth-child(2) {
    opacity: 0;
  }

  .bar.open:nth-child(3) {
    transform: rotate(-45deg) translate(6px, -6px);
  }

  @media (max-width: 768px) {
    display: flex;
    position: absolute;
    left: 20px;
  }
`;
